'use client';

import React, { useState } from 'react';

import { IconEye, IconEyeSlash } from '@icons';
import Input from './Input';

interface InputPasswordProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  htmlFor?: string;
  className?: string;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
}

const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(
  (
    {
      className = '',
      label,
      htmlFor,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      id,
      disabled,
      ...props
    },
    ref
  ) => {
    const [revealed, setRevealed] = useState(false);
    const inputType = revealed ? 'text' : 'password';
    const labelFor = htmlFor ?? id;

    return (
      <>
        {label ? <label htmlFor={labelFor}>{label}</label> : null}
        <div className='input-affix input-password'>
          <Input
            id={id}
            ref={ref}
            className={className}
            type={inputType}
            hint={undefined}
            disabled={disabled}
            {...props}
          />
          <button
            type='button'
            onClick={() => setRevealed((v) => !v)}
            className='affix-icon affix-icon-button'
            aria-label={revealed ? 'Hide password' : 'Show password'}
            disabled={disabled}
          >
            {revealed ? <IconEye /> : <IconEyeSlash />}
          </button>
        </div>
        {hint ? (
          <small
            id={hintId}
            hidden={hintHidden}
            className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
          >
            {hint}
          </small>
        ) : null}
      </>
    );
  }
);

InputPassword.displayName = 'InputPassword';

export default InputPassword;
